/**
 * Target's mark: three panels of the exam screen — a header, the passage and
 * the questions. The T is the gap between them.
 *
 * The header is always Target red. The two panels take the text colour
 * (currentColor), so the mark is dark on paper and white on the navy rail
 * without a second version.
 *
 * Below 24px the gaps would shrink under two pixels and the T would close
 * up, so small sizes draw wider gaps and tighter corners.
 */
export function TargetMark({ size = 24, className }: { size?: number; className?: string }) {
  const small = size < 24;
  return (
    <svg
      className={className}
      width={size}
      height={size}
      viewBox="0 0 64 64"
      aria-hidden="true"
      focusable="false"
    >
      {small ? (
        <>
          <path d="M4 11 A7 7 0 0 1 11 4 H53 A7 7 0 0 1 60 11 V16 A2 2 0 0 1 58 18 H6 A2 2 0 0 1 4 16 Z" fill="#cf1a2b" />
          <path d="M4 28 A2 2 0 0 1 6 26 H26 A2 2 0 0 1 28 28 V58 A2 2 0 0 1 26 60 H11 A7 7 0 0 1 4 53 Z" fill="currentColor" />
          <path d="M36 28 A2 2 0 0 1 38 26 H58 A2 2 0 0 1 60 28 V53 A7 7 0 0 1 53 60 H38 A2 2 0 0 1 36 58 Z" fill="currentColor" />
        </>
      ) : (
        <>
          <path d="M4 12 A8 8 0 0 1 12 4 H52 A8 8 0 0 1 60 12 V17 A3 3 0 0 1 57 20 H7 A3 3 0 0 1 4 17 Z" fill="#cf1a2b" />
          <path d="M4 28 A3 3 0 0 1 7 25 H26.5 A3 3 0 0 1 29.5 28 V57 A3 3 0 0 1 26.5 60 H12 A8 8 0 0 1 4 52 Z" fill="currentColor" />
          <path d="M34.5 28 A3 3 0 0 1 37.5 25 H57 A3 3 0 0 1 60 28 V52 A8 8 0 0 1 52 60 H37.5 A3 3 0 0 1 34.5 57 Z" fill="currentColor" />
        </>
      )}
    </svg>
  );
}
